package com.gastoncantera.intercom.call

import com.shepeliev.webrtckmp.MediaStreamConstraintsBuilder
import com.shepeliev.webrtckmp.PeerConnection

internal actual fun MediaStreamConstraintsBuilder.applyVideoCaptureConstraints() {
    video()
}

internal actual suspend fun PeerConnection.capVideoSendBitrate() {}
